import { UndoOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";

function UnbanButton({
	handleClick,
}: { handleClick: () => void; }) {
	return (
    <Tooltip title={"Unban"}>
        <Button
            variant="outlined"
            onClick={handleClick}
			icon={<UndoOutlined />}
		/>
    </Tooltip>
	);
}

export default UnbanButton;
